import { render } from "./MinhaConta.vue?vue&type=template&id=363b15f3&scoped=true"
import script from "./MinhaConta.vue?vue&type=script&lang=js"
export * from "./MinhaConta.vue?vue&type=script&lang=js"

import "./MinhaConta.vue?vue&type=style&index=0&id=363b15f3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\musta\\Área de Trabalho\\Projetos\\catalogo\\catalogo-pedidos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-363b15f3"]])

export default __exports__